module.exports = __webpack_public_path__ + "img/p4.3936e850.png";